import { ReactNode, useCallback, useState } from "react";
import { NavLink } from "react-router";
import t from "@/lang/lang";
import {
  SummaryBaseDataTable,
  SummaryBaseDataTableFilters,
  useDefaultHtzSummaryBaseDataListRequest,
} from "@/services/backend/htz/summary/components/summary-base-data-table";
import { CreateSummaryBaseDataDialog } from "@/services/backend/htz/summary/components/create-summary-base-data-dialog";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export function SummariesRoute() {
  const [request, setRequest] = useState(
    useDefaultHtzSummaryBaseDataListRequest(),
  );

  const renderRowLink = useCallback(
    (baseDataId: string, children: ReactNode) => (
      <NavLink to={baseDataId}>{children}</NavLink>
    ),
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Inspektionsberichte")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Sie die Vorgabewerte verwalten, mit denen ein neuer Inspektionsbericht angelegt wird. Die als aktiv markierten Basisdaten werden dafür verwendet.",
          )}
        </CardDescription>
        <CardAction>
          <CreateSummaryBaseDataDialog />
        </CardAction>
      </CardHeader>
      <CardContent className="grid gap-2">
        <SummaryBaseDataTableFilters
          request={request}
          onRequestChange={setRequest}
        />
        <SummaryBaseDataTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={renderRowLink}
          hideBorder
        />
      </CardContent>
    </Card>
  );
}
